<template>
  <div class="animated fadeIn upload-prk">
    <b-card v-if="!showUploadFrm">
      <div slot="header">
        Hasil Import Data Pinjaman RK(Rekening Koran)
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="confirmSave=!confirmSave" :disabled="!saveEnabled">
            <i class="fa fa-save"></i> Save
          </button>
          <button class="btn btn-primary mr-1" @click="cancel()">
            <i class="fa fa-close"></i> {{$t('cancel')}}
          </button>
        </div>
      </div>
      <b-card no-body>
        <template v-slot:header v-if="(filterShow=='Hide')">
          <b-row>
            <b-col lg="3">
              <b-input-group size="sm" class="mt-1">
                <b-input-group-prepend>
                  <span class="pt-1 mr-1">FILTER</span>
                </b-input-group-prepend>
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                <b>{{ filterShow }}</b> Filter
              </b-form-checkbox>
            </b-col>
            <b-col lg="9">
              <b-form-group
                label="FILTER ON :"
                label-cols-sm="1"
                description="Leave all unchecked to filter on all data"
                class="mb-0"
              >
                <b-form-checkbox-group v-model="filterOn" class="mt-1">
                  <b-form-checkbox
                    v-for="(item,index) in tblLcy.fields.filter(dt => dt.filterable==true) "
                    :key="index"
                    :value="item.key"
                  >{{item.label}}</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
        </template>
        <b-table
          class="mb-0 text-nowrap"
          ref="tableOri"
          sticky-header="600px"
          outlined
          responsive
          striped
          hover
          style="font-size:smaller;"
          :items="rptLines"
          :fields="tblLcy.fields"
          :current-page="tblLcy.page"
          :per-page="tblLcy.limit"
          :sort-by.sync="tblLcy.sortBy"
          :sort-desc.sync="tblLcy.sortDesc"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
        >
          <template v-slot:cell(tgl_kontrak)="data">
            <span v-if="(data.item.tgl_kontrak)">{{ data.item.tgl_kontrak | moment("DD-MMM-YYYY") }}</span>
          </template>
          <template
            v-slot:cell(nilaiori)="data"
          >{{ data.item.matauang }} &nbsp; {{ data.item.nilaiori | numFormat }}</template>
          <template v-slot:cell(plafon)="data">{{ data.item.plafon | numFormat('0,0.00') }}</template>
          <template
            v-slot:cell(bunga_tarifthn)="data"
          >{{ data.item.bunga_tarifthn | numFormat('0,0.00') }}</template>
          <template
            v-slot:cell(bungaod_tarifthn)="data"
          >{{ data.item.bungaod_tarifthn | numFormat('0,0.00') }}</template>
          <template v-slot:cell(interest)="data">{{ data.item.interest | numFormat('0,0.00') }}</template>
          <template
            v-slot:cell(paym_total_amount)="data"
          >{{ data.item.paym_total_amount | numFormat('0,0.00') }}</template>
          <template
            v-slot:cell(principal_outstand)="data"
          >{{ data.item.principal_outstand | numFormat('0,0.00') }}</template>
          <template
            v-slot:cell(interest_outstand)="data"
          >{{ data.item.interest_outstand | numFormat('0,0.00') }}</template>
          <template v-slot:custom-foot>
            <b-tr>
              <b-td colspan="8">
                <h6 class="text-right">Sub Total:</h6>
              </b-td>
              <b-td>
                <h6 class="text-right">{{total.paym_total_amount | numFormat('0,0.00')}}</h6>
              </b-td>
              <b-td>
                <h6 class="text-right">{{total.principal_outstand | numFormat('0,0.00')}}</h6>
              </b-td>
              <b-td>
                <h6 class="text-right">{{total.interest_outstand | numFormat('0,0.00')}}</h6>
              </b-td>
              <b-td>&nbsp;</b-td>
            </b-tr>
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col cols="4">
            Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
            to
            <span
              v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
            >{{tblLcy.total}}</span>
            <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
            of {{tblLcy.total}} entries,
          </b-col>
          <b-col cols="4">
            <b-row class="justify-content-center">
              <b-col cols="12">
                <div style="display: flex;margin:0;padding:0;">
                  <div style="margin:0;padding:5px;width:500px; text-align:center;">
                    <span class="mr-1">limit per page :</span>
                    <select v-model="tblLcy.limit" style="width:60px;">
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>
                      <option>25</option>
                      <option>30</option>
                      <option>40</option>
                      <option>50</option>
                      <option>60</option>
                      <option>70</option>
                      <option>80</option>
                      <option>90</option>
                    </select>
                  </div>
                </div>
              </b-col>
              <b-col cols="12">
                <div style="display: flex;margin:0;padding:0;">
                  <div style="margin:0;padding:5px;width:500px; text-align:center;">
                    <b-form-checkbox
                      v-model="filterShow"
                      value="Hide"
                      unchecked-value="Show"
                      switch
                    >
                      <b>{{ filterShow }}</b> Filter
                    </b-form-checkbox>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="4">
            <div>
              <b-pagination
                class="ml-1"
                align="right"
                :total-rows="tblLcy.total"
                :per-page="tblLcy.limit"
                v-model="tblLcy.page"
              ></b-pagination>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-card>
    <b-row align-h="center" v-else>
      <b-col md="8">
        <b-card>
          <div slot="header">
            Import Data Pinjaman RK(Rekening Koran)
            <div class="card-header-actions">
              <div>
                <b-button class="btn-normal alert mb-2 mr-2" @click="close">
                  <i class="fa fa-times"></i> Close
                </b-button>
              </div>
            </div>
          </div>

          <b-card class="ColsDefine">
            <strong>Difinisi nama Kolom Excel untuk setiap Fileld pada data Pinjaman</strong>
            <b-row>
              <b-col lg="4">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Debitur No</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.CustCode"
                    :state="!$v.frmUpload.CustCode.$error"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Nama Debitur</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.CustName"
                    :state="!$v.frmUpload.CustName.$error"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>No. KTP Debitur</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.ktp" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Alamat Debitur</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.alamat" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Kelurahan Debitur</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.kelurahan" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Kecamatan Debitur</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.kecamatan" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Kabupaten Debitur</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.kabupaten" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Kodepos Debitur</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.kodepos" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="4">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Total Plafond</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.plafon"
                    :state="!$v.frmUpload.plafon.$error"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Bunga(%)/Tahun</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.bunga_tarifthn"
                    :state="!$v.frmUpload.bunga_tarifthn.$error"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Bunga OD(%)/Tahun</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.bungaod_tarifthn"
                    :state="!$v.frmUpload.bungaod_tarifthn.$error"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Tgl. Cair</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.startdate" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Jatuh Tempo</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.duedate" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Saldo Pokok</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.principal_outstand"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Saldo Bunga</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.interest_outstand"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="4">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>No. Kontrak</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.no_kontrak" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Tgl. Kontrak</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.tgl_kontrak" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Status Collection</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.collectability"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
              </b-col>
            </b-row>
          </b-card>
          <b-input-group>
            <b-input-group-prepend>
              <label>Choose *.XLSX file</label>
            </b-input-group-prepend>
            <b-form-file
              v-model="fileXlsx"
              :state="!$v.fileXlsx.$error"
              placeholder="Choose a XLSX file..."
              drop-placeholder="Drop XLSX file here..."
            ></b-form-file>
          </b-input-group>
          <b-row no-gutters>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Nama SHEET</label>
                </b-input-group-prepend>
                <b-form-input v-model="frmUpload.sheetName" :state="!$v.frmUpload.sheetName.$error"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-append>
                  <label class="input-group-text ml-1">Data mulai baris ke-</label>
                </b-input-group-append>
                <b-form-input
                  v-model="frmUpload.startRow"
                  type="number"
                  :state="!$v.frmUpload.startRow.$error"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <div slot="footer" class="text-center">
            <b-button variant="primary" @click="importdata()">Import</b-button>
            <b-button variant="danger" @click="close()">Cancel</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="modal-prevent-closing"
      ref="modal"
      title="Konfirmasi"
      v-model="confirmSave"
      @ok="saveimportdata"
    >
      <div class="my-2 text-center">
        <p>Anda akan memproses data ini.</p>
        <p>Apakah anda yakin?</p>
      </div>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.upload-prk {
  iframe {
    border: 1px solid #ccc;
    width: 100%;
    height: 11in;
  }
  .ColsDefine {
    .input-group {
      .input-group-prepend {
        label {
          width: 135px !important;
        }
      }
    }
  }
}
</style>

<script>
import myNumber from "../../components/my-number";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import crud from "../../apis/crud";
import kolomXls from "../../data/kolomXls.json";
import pinjaman from "../../apis/pinjamankredit";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmUpload: {
      sheetName: { required },
      startRow: { required },
      CustCode: { required },
      CustName: { required },
      plafon: { required },
      bunga_tarifthn: { required },
      bungaod_tarifthn: { required },
    },
    fileXlsx: { required },
  },
  data() {
    return {
      showUploadFrm: true,
      confirmSave:false,
      saveEnabled:true,
      fileXlsx: null,
      frmUpload: {
        sheetName: "DAFTAR_PINJAMAN_PRK",
        startRow: 4,
        application_no: "B",
        no_kontrak: "A",
        tgl_kontrak: "DR",
        CustCode: "C",
        CustName: "D",
        alamat: "DA",
        uraian: "M",
        plafon: "FC",
        bunga_tarifthn: "P",
        bungaod_tarifthn: "Q",
        paym_total_amount: "FC",
        principal_outstand: "AM",
        interest_outstand: "AN",
        // jnsjaminan: "DE",
      },
      kolomXls: kolomXls,
      isLoading: false,
      showReport: false,
      reportUrl: `${location.origin}/#load`,
      model: { account: "", tgl1: "", tgl2: "" },
      uanguser: this.$store.state.user.matauang,
      accounts: [],
      rptLines: [],
      subtotal: {},
      filterShow: "Show",
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "no_kontrak",
            label: "No.Kontrak",
            sortable: true,
            filterable: true,
          },
          {
            key: "tgl_kontrak",
            label: "tgl. Kontrak",
            thStyle: "width:90px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "CustName",
            label: "Nama Debitur",
            filterable: true,
          },
          {
            key: "alamat",
            label: "Alamat Debitur",
            sortable: true,
            filterable: true,
          },
          {
            key: "plafon",
            label: "Total Plafond",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            filterable: true,
          },
          {
            key: "bunga_tarifthn",
            label: "Bunga(%)",
            thStyle: "width:80px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "bungaod_tarifthn",
            label: "Bunga OD / tahun (%)",
            thStyle: "width:80px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "interest",
            label: "Total Bunga",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "paym_total_amount",
            label: "Total Pembayaran",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "principal_outstand",
            label: "Sisa Pokok",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "interest_outstand",
            label: "Sisa Bunga",
            thStyle: "width:140px",
            thClass: "text-right ",
            tdClass: "text-right",
          },
          {
            key: "collectability",
            label: "Kolektabilitas",
            thStyle: "width:140px",
            thClass: "text-right ",
            tdClass: "text-right",
            filterable: true,
          },
        ],
      },
      filter: null,
      filterOn: [],
      total: {
        paym_total_amount: 0,
        principal_outstand: 0,
        interest_outstand: 0,
      },
    };
  },
  components: { Loading, myNumber },
  computed: {
    invalidFrmUpload() {
      this.$v.frmUpload.$touch();
      return this.$v.frmUpload.$invalid;
    },
    invalidFileXlsx() {
      this.$v.fileXlsx.$touch();
      return this.$v.fileXlsx.$invalid;
    },
  },
  watch: {
    account: function (newval) {
      const obj = this.accounts.find((d) => d.value === newval);
      this.model.namaacc = obj.text || "";
      this.model.kodeacc = obj.kodeacc;
      // console.log(`${this.model.account} | ${this.model.namaacc}`);
    },
    rptLines(value) {
      this.calcsum(value);
    },
  },
  created: async function () {
    const collSet = { tablename: "uploadprk" };
    const uploadDt = await crud.list(collSet);
    if (uploadDt.length > 0) {
      const objDt = uploadDt[0];
      for (const key in objDt) {
        if ((objDt[key] || "") != "") {
          this.frmUpload[key] = objDt[key];
        }
      }
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;

      // calc 
      const total = {
        paym_total_amount: 0,
        principal_outstand: 0,
        interest_outstand: 0,
      };
      filteredItems.map((item) => {
        total.paym_total_amount += item.paym_total_amount;
        total.principal_outstand += item.principal_outstand;
        total.interest_outstand += item.interest_outstand;
      });
      this.total = total;
    },
    clearFilter() {
      this.filterOn = [];
      this.filter = "";
    },
    calcsum(result) {
      const total = {
        paym_total_amount: 0,
        principal_outstand: 0,
        interest_outstand: 0,
      };
      result.map((item) => {
        total.paym_total_amount += item.paym_total_amount;
        total.principal_outstand += item.principal_outstand;
        total.interest_outstand += item.interest_outstand;
      });
      this.total = total;
    },
    async importdata() {
      if (this.invalidFrmUpload || this.invalidFileXlsx) {
        toastr.error("Please fill the form correctly.");
      } else {
        try {
          this.isLoading = true;
          const result = await pinjaman.importdtPRKxls(
            this.fileXlsx,
            this.frmUpload
          );
          this.rptLines = result;
          this.tblLcy.total = result.length;
          this.showUploadFrm = false;
          this.isLoading = false;
          this.saveEnabled=true;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    async saveimportdata() {
      if (this.rptLines.length == 0) {
        toastr.warn("Data is empty");
      } else {
        try {
          this.isLoading = true;
          this.saveEnabled=false;
          await pinjaman.savebulkdtPinjaman(this.rptLines);
          this.showUploadFrm = true;
          toastr.success("Data berhasil diimport");
          this.isLoading = false;
          this.saveEnabled=true;
        } catch (error) {
          this.isLoading = false;
          this.saveEnabled=true;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    close() {
      router.push("home");
    },
    cancel() {
      this.showUploadFrm = true;
      this.tblLcy.items = [];
      this.total = {
        paym_total_amount: 0,
        principal_outstand: 0,
        interest_outstand: 0,
      };
    },
  },
};
</script>
